'use client';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  FRIENDS_TAB_COUNTS_QUERY_KEY,
  SENT_REQUESTS_QUERY_KEY,
} from '@/modules/players/v3/constants/friends';
import { RELATIONSHIP_QUERY_KEY } from '@/modules/players/v3/hooks/use-get-relationship';
import { revokeFriendRequest } from '@/utils/actions/players/friends/revokeFriendRequest';

export interface UseRevokeFriendRequestParams {
  uuid: string;
  friendUuid: string;
}

export const useRevokeFriendRequest = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ uuid, friendUuid }: UseRevokeFriendRequestParams) => {
      const res = await revokeFriendRequest({ uuid, friendUuid });
      if (res.error) {
        throw new Error(`Failed to revoke friend request: ${res.error}`);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [SENT_REQUESTS_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [FRIENDS_TAB_COUNTS_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [RELATIONSHIP_QUERY_KEY] });
    },
  });
};
